const Sdata = [
    {
        id     :"num_0",
        img    :"https://images.geekster.in/placed/Vamsi-Krishna.webp",
        name   :"Vamsi Krishna",
        company:"https://images.geekster.in/hiring-partners/avizva.webp",
        about  :"I have had a great learning experience with Geekster. They not just focus on technical skills but prepare us for interviews through soft-skills training as well. "
        },
        {
        id     :"num_1",
        img    :"https://images.geekster.in/placed/Ashwini-Kumar.webp",
        name   :"Ashwini Kumar",
        company:"https://images.geekster.in/hiring-partners/ivy.webp",
        about  :"I am currently going through the full-stack development program at Geekster and I couldn’t be happier with the pace of learning and support provided by my mentors. We are learning live coding with the help of Aman Sir’s constant encouragement and guidance."
        },
        {
        id     :"num_2",
        img    :"https://images.geekster.in/placed/Anurag-Ojha.webp",
        name   :"Anurag Ojha",
        company:"https://images.geekster.in/hiring-partners/skillgigs.webp",
        about  :"I was struggling in my initial days, because I wasn't getting a decent salary. To be honest, when I heard of Geekster's ISA program, I thought there must be some hidden charges. But I still wanted to take a chance and to my surprise, I had to pay the fees only after I got my job and that too in installments."
        },
        {
        id     :"num_3",
        img    :"https://images.geekster.in/placed/Utkarsh-Singh.webp",
        name   :"Utkarsh Singh",
        company:"https://images.geekster.in/hiring-partners/Bluewud.webp",
        about  :"Geekster taught me in months what years of college work couldn't teach me. They honed my technical and non-technical skills, build my confidence and gave me a flavor of what it would look like working in the industry."
        },
        {
        id     :"num_4",
        img    :"https://images.geekster.in/placed/Rohit-Kumar.webp",
        name   :"Rohit Kumar",
        company:"https://images.geekster.in/hiring-partners/NetCore-cloud.webp",
        about  :"I wanted to sharpen my technical skills, including Java and DSA, and that's why I joined Geekster. All the mentors helped me a lot to improve my technical skills. As a result, I got placed at Netcore Cloud."
        },
        {
        id     :"num_5",
        img    :"https://images.geekster.in/placed/Prasang-Chouksey.webp",
        name   :"Prasang Chouksey",
        company:"https://images.geekster.in/hiring-partners/genpact.webp",
        about  :"When I began the Geekster course, I knew the transition from a Mechanical Engineer to a Software Developer is not going to be easy. Obviously, it wasn't easy to say the least. But there was constant, support, and guidance that helped me become today what I am. Everyone at Geekster worked together as a team to shape my career."
        },
        {
        id     :"num_6",
        img    :"https://images.geekster.in/placed/Karthikeyan-Palani.webp",
        name   :"Karthikeyan Palani",
        company:"https://images.geekster.in/hiring-partners/Ramco-Systems.webp",
        about  :"I've constantly been looking for a good company, and Geekster helped me upgrade my skills. Once I finished the course I had job offers from some top brands."
        },
        {
        id     :"num_7",
        img    :"https://images.geekster.in/placed/Karan-Kishore-Bairagi.webp",
        name   :"Karan Kishore",
        company:"https://images.geekster.in/hiring-partners/analytic-edge.webp",
        about  :"I had an awesome experience at Geekster and I can proudly say that my technical and soft-skills have improved drastically and helped me get a job. The trainers and mentors are highly knowledgeable and dedicated to help students. They are easily accessible and ready to guide us and clear all our doubts."
        },
        {
        id     :"num_8",
        img    :"https://images.geekster.in/placed/JALAL-UDDIN-SK.webp",
        name   :"Jalal Uddin SK",
        company:"https://images.geekster.in/hiring-partners/sarvagram.webp",
        about  :"After taking so many courses from different institutes, I realized that no one takes full responsibility for their students. They can refer you only for the junior positions with less pay. But Geekster is different. It charges 2 lakh rupees from you but provides you with everything you need to succeed in your career."
        },
        {
        id     :"num_9",
        img    :"https://images.geekster.in/placed/Chetan.webp",
        name   :"Chetan",
        company:"https://images.geekster.in/hiring-partners/societe-generale.webp",
        about  :"Expert tutors, excellent courses, and a guranteed job.. That's Geekster for you! Will highly recommend it to all my friends looking for a job or a switch."
        },
        {
        id     :"num_10",
        img    :"https://images.geekster.in/placed/Amanpreet-Singh.webp",
        name   :"Amanpreet Singh",
        company:"https://images.geekster.in/hiring-partners/PayPal.webp",
        about  :"Just after a year of experience, when my counterparts are still getting hold of the industry, Geekster had already skyrocketed my career! Than kyou wonderful mentors and trainees at Geekster for honing my skills and instilling so much confidence in me."
        },

];
export default Sdata;